import React, { useState } from "react";
import Grid from "@material-ui/core/Grid";
import DateFnsUtils from "@date-io/date-fns";
import Button from "react-bootstrap/Button";
import axios from "axios";
// import { Button, ButtonGroup, Modal } from "react-bootstrap";
import IconButton from "@mui/material/IconButton";
import Input from "../../UI/Input";
import CloseIcon from "@material-ui/icons/Close";
import {
  KeyboardDateTimePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import OperatorHelpNotes from "../OperatorHelpNotes";
import { API_URL } from "../../ConstVariable";
import Loading from "../../Logo/loader.gif";
const AddmoreOrder = ({
  Id,
  orderDetails,
  orderListArray,
  setOrderListArray,
  rerender,
  setRerender,
  addExtraOrderhandler,
  centerId,
}) => {
  // console.log("ID ", Id);
  const [order, setOrder] = useState(orderDetails);
  const handleDateTimeChange = (time) => {
    let arr = orderListArray;
    let i = Id;
    setOrder({ ...order, ["schedule_datetime"]: time });
    let SelectedDateTimeZone = new Date(time);

    let month = SelectedDateTimeZone.getMonth() + 1;
    let year = SelectedDateTimeZone.getFullYear();
    let date = SelectedDateTimeZone.getDate();
    // console.log("Month", month, year, date);

    let finalDate = `${year}-${month}-${date}`;

    let TimeTaken = new Date(time).toTimeString();

    let TimeTakenSplit = TimeTaken.split(" ");

    let appointedDateTime = `${finalDate} ${TimeTakenSplit[0]}`;

    arr[i] = { ...order, ["schedule_datetime"]: appointedDateTime };
    setOrderListArray(arr);
    setRerender(true);
  };

  const dateTimePicker = () => {
    return (
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <Grid>
          <KeyboardDateTimePicker
            variant="dialog"
            value={order.schedule_datetime}
            onChange={handleDateTimeChange}
            emptyLabel=" "
            onError={console.log}
            format="dd/MM/yyyy hh:mm a"
          />
        </Grid>
      </MuiPickersUtilsProvider>
    );
  };
  const [operatorNotesShouldFetch, operatorNotesFetchHandler] = useState(false);

  const [searchDescriptionTimerId, setSearchDescriptionTimerId] =
    useState(null);
  const [isScanSearchBeingProcess, setIsScanSearchBeingProcess] =
    useState(false);

  console.log("ORDER", order);
  const inputChangedHandler = (event, inputIdentifier) => {
    let orderItemList = orderListArray;
    let orderItemIndex = Id;

    console.log(event.target.value);

    setOrder({
      ...order,
      [inputIdentifier]:
        inputIdentifier === "roomName"
          ? event.target.value.toUpperCase()
          : event.target.value,
    });
    orderItemList[orderItemIndex] = {
      ...order,
      [inputIdentifier]:
        inputIdentifier === "roomName"
          ? event.target.value.toUpperCase()
          : event.target.value,
    };
    setOrderListArray(orderItemList);
    setRerender(true);
    if (
      inputIdentifier === "order_description" &&
      event.target.value.trim().length > 1
    ) {
      let token = localStorage.getItem("MyToken");

      clearTimeout(searchDescriptionTimerId);

      let timerId = setTimeout(() => {
        setIsScanSearchBeingProcess(true);
        axios({
          method: "post",
          url: API_URL + "/oi/api/v1/ScanTypeDetails",
          data: {
            scan_desc: event.target.value,
            center_id:centerId
          },
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true
        })
          .then((res) => {
            let data = res.data;

            if (data) {
              let pregnancyWeeks = "";
              if (data?.is_pregnancy_flow) {
                /*
              input tag does not take the null value , If we pass the null to the input tag , it will not reset the value because input tag accept the string
              --
              Here we are passing the string if value id nulll
              */
                pregnancyWeeks = !data.weeks_since_pregnant
                  ? order.weeks_since_pregnant
                    ? order.weeks_since_pregnant
                    : ""
                  : data.weeks_since_pregnant;
              }

              setOrder((prevState) => {
                return {
                  ...prevState,
                  // order_description:event.target.value,
                  bodypart: data?.bodypart.toUpperCase(),
                  bodypart_group: data?.bodypart_group.toUpperCase(),
                  laterality: data?.laterality.toUpperCase(),
                  modality: data?.modality.toUpperCase(),
                  protocol: data?.protocol.toUpperCase(),
                  purpose_of_study: data?.purpose_of_study.toUpperCase(),
                  weeks_since_pregnant: pregnancyWeeks,
                  is_pregnancy_flow: data?.is_pregnancy_flow,
                  modalityGeneric: data.modality_generic,
                  bodypartGeneric: data.bodypart_generic,
                  protocolGeneric: data.protocol_generic,
                  purposeOfStudyGeneric: data.purpose_of_study_generic,
                  lateralityGeneric: data.laterality_generic,
                  bodypartGroupGeneric: data.bodypart_group_generic,
                  speciality:data.speciality,
                  ris_service_code:data.ris_service_code
                };
              });

              orderItemList[orderItemIndex] = {
                ...order,
                order_description: event.target.value,
                bodypart: data?.bodypart.toUpperCase(),
                bodypart_group: data?.bodypart_group.toUpperCase(),
                laterality: data?.laterality.toUpperCase(),
                modality: data?.modality.toUpperCase(),
                protocol: data?.protocol.toUpperCase(),
                purpose_of_study: data?.purpose_of_study.toUpperCase(),
                weeks_since_pregnant: pregnancyWeeks,
                is_pregnancy_flow: data?.is_pregnancy_flow,
                modalityGeneric: data.modality_generic,
                bodypartGeneric: data.bodypart_generic,
                protocolGeneric: data.protocol_generic,
                purposeOfStudyGeneric: data.purpose_of_study_generic,
                lateralityGeneric: data.laterality_generic,
                bodypartGroupGeneric: data.bodypart_group_generic,
                speciality:data.speciality,
                ris_service_code:data.ris_service_code
              };
              setOrderListArray(orderItemList);
            } else {
              setOrder((prevState) => {
                return {
                  ...prevState,
                  bodypart: "",
                  bodypart_group: "",
                  laterality: "",
                  modality: "",
                  protocol: "",
                  purpose_of_study: "",
                  weeks_since_pregnant: "",
                  is_pregnancy_flow: false,
                  modalityGeneric: "",
                  bodypartGeneric: "",
                  protocolGeneric: "",
                  purposeOfStudyGeneric: "",
                  lateralityGeneric: "",
                  bodypartGroupGeneric: "",
                  ris_service_code:""
                };
              });

              orderItemList[orderItemIndex] = {
                ...order,
                bodypart: "",

                bodypart_group: "",
                laterality: "",
                modality: "",
                protocol: "",
                purpose_of_study: "",
                weeks_since_pregnant: "",
                is_pregnancy_flow: false,
                modalityGeneric: "",
                bodypartGeneric: "",
                protocolGeneric: "",
                purposeOfStudyGeneric: "",
                lateralityGeneric: "",
                bodypartGroupGeneric: "",
                ris_service_code:""
              };

              setOrderListArray(orderItemList);
            }
            setIsScanSearchBeingProcess(false);
            operatorNotesFetchHandler(true);
          })
          .catch((e) => {
            console.log("Error", e);
            //  SetErrorForDisplay({
            //    severity: "warning",
            //    message: e.message,
            //  });
            setIsScanSearchBeingProcess(false);
            operatorNotesFetchHandler(false);
          });
        clearTimeout(searchDescriptionTimerId);
        clearTimeout(timerId);
      }, 1000);

      setSearchDescriptionTimerId(timerId);
    }
  };

  const removeHandler = () => {
    let i = Id;

    console.log("KEY Remove", i);
    let arr = orderListArray;
    arr.splice(i, 1);

    console.log("Updated Array", arr);
    setOrderListArray((preview) => [...arr]);
    setRerender(true);
  };

  return (
    <div
      style={{
        position: "relative",
        // borderBottom: "1px solid lightgrey",
      }}
    >
      <div onClick={removeHandler} style={{ marginBottom: "10px" }}>
        <IconButton
          style={{
            // background: "white",
            // width: "20px",
            // height: "20px",
            cursor: "pointer",
            // borderRadius: "50%",
            position: "absolute",
            top: "-25px",
            right: "0",
          }}
        >
          <CloseIcon
          // style={{
          //   background: "white",
          //   width: "20px",
          //   height: "20px",
          //   cursor: "pointer",
          //   borderRadius: "50%",
          //   position: "absolute",
          //   top: "-25px",
          //   right: "0",
          // }}
          />
        </IconButton>
      </div>

      <OperatorHelpNotes
        orderDetails={order}
        center_id={centerId}
        modality={order.modality}
        bodypart={order.bodypart}
        bodypart_group={order.bodypart_group}
        protocol={order.protocol}
        purpose_of_study={order.purpose_of_study}
        laterality={order.laterality}
        operatorNotesShouldFetch={operatorNotesShouldFetch}
        operatorNotesFetchHandler={(data) => operatorNotesFetchHandler(data)}
        pregnancyWeeks={order.weeks_since_pregnant}
        conversationID={order.conversationID}
        modalityGeneric={order.modalityGeneric}
        bodypartGeneric={order.bodypartGeneric}
        protocolGeneric={order.protocolGeneric}
        purposeOfStudyGeneric={order.purposeOfStudyGeneric}
        lateralityGeneric={order.lateralityGeneric}
        bodypartGroupGeneric={order.bodypartGroupGeneric}
        speciality={order.speciality}
        order_description={order.order_description}
      />
      <div
        className="addOrder"
        style={{
          marginTop: "20px",
          borderBottom: "1px solid lightgrey",
          paddingBottom: "5px",
        }}
      >
        <table>
          <tr>
            <td
              style={{ width: "7%", fontSize: "16", paddingRight: "7px" }}
              title={"Description"}
            >
              Des:
            </td>
            <td>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Input
                  width="100%"
                  placeholder="Description"
                  fontSize="17"
                  Value={order.order_description}
                  onChange={(event) =>
                    inputChangedHandler(event, "order_description")
                  }
                />
                {isScanSearchBeingProcess && (
                  <img
                    src={Loading}
                    style={{ marginLeft: "5px", width: "30px" }}
                  />
                )}
              </div>
            </td>
          </tr>
        </table>
        <table style={{ width: "100%" }}>
          <tr>
            <td title={"Modality"}>Mod:</td>
            <td>
              <Input
                id="modality"
                key="modality"
                name="modality"
                width="96%"
                textTransform="capitalize"
                placeholder="Modality"
                Value={order.modality ? order.modality.toUpperCase() : ""}
                onChange={(event) => inputChangedHandler(event, "modality")}
                disabled={true}
              />
            </td>
            <td title={"Bodypart"}>BP:</td>
            <td>
              <Input
                id="body_part"
                key="bodypart"
                name="bodypart"
                width="100%"
                textTransform="capitalize"
                placeholder="Bodypart"
                Value={order.bodypart}
                onChange={(event) => inputChangedHandler(event, "bodypart")}
                disabled={true}
              />
            </td>
          </tr>

          <tr>
            <td title={"Study Protocol"}>PT:</td>
            <td>
              <Input
                id="protocol"
                key="protocol"
                label="protocol"
                name="protocol"
                width="96%"
                textTransform="capitalize"
                placeholder="protocol"
                Value={order.protocol}
                onChange={(event) => inputChangedHandler(event, "protocol")}
                disabled={true}
              />
            </td>
            <td title={"Purpose of study"}>PP:</td>
            <td>
              <Input
                id="purposeOfStudy"
                key="purposeOfStudy"
                label="purposeOfStudy"
                name="purposeOfStudy"
                textTransform="capitalize"
                width="100%"
                placeholder="Purpose of study"
                Value={order.purpose_of_study}
                onChange={(event) =>
                  inputChangedHandler(event, "purpose_of_study")
                }
                disabled={true}
              />{" "}
            </td>
          </tr>

          <tr>
            <td title={"Laterality"}>Lat:</td>
            <td>
              <Input
                id="laterality"
                key="laterality"
                label="laterality"
                name="laterality"
                textTransform="capitalize"
                width="96%"
                placeholder="laterality"
                Value={order.laterality}
                onChange={(event) => inputChangedHandler(event, "laterality")}
                disabled={true}
              />
            </td>
            <td title={"Bodypart group"}>BG:</td>
            <td>
              <Input
                id="bodypartGroup"
                key="bodypartGroup"
                label="bodypartGroup"
                name="bodypartGroup"
                textTransform="capitalize"
                width="100%"
                placeholder="Bodypart group"
                Value={order.bodypart_group}
                onChange={(event) =>
                  inputChangedHandler(event, "bodypart_group")
                }
                disabled={true}
              />
            </td>
          </tr>
          <tr>
            <td title={"RIS Service Code"}>RSC:</td>
            <td>
              <Input
                id="ris_service_code"
                key="ris_service_code"
                label="ris_service_code"
                name="ris_service_code"
                textTransform="capitalize"
                width="96%"
                placeholder="RIS Service Code"
                Value={order.ris_service_code}
                onChange={(event) => 
                  inputChangedHandler(event, "ris_service_code")
                }
                disabled={true}
              />
            </td>
            <td></td>
            <td></td>
          </tr>
          {/* to give the horizontal line  */}
          <div style={{width:"100%", marginTop:"5px", marginBottom:"5px"}}></div>
          <tr style={{border:"1px solid lightgrey"}}></tr>
          <div style={{width:"100%", marginTop:"5px", marginBottom:"5px"}}></div>
          <tr>
            <td title={"Modality generic"}>Mod-G:</td>
            <td>
              <Input
                id="modalityGeneric"
                key="modalityGeneric"
                name="modalityGeneric"
                width="96%"
                placeholder="Modality Generic"
                Value={
                  order.modalityGeneric
                    ? order.modalityGeneric.toUpperCase()
                    : ""
                }
                onChange={(event) =>
                  inputChangedHandler(event, "modalityGeneric")
                }
                disabled={true}
              />
            </td>
            <td title={"Bodypart generic"}>BP-G:</td>
            <td>
              <Input
                textTransform="capitalize"
                id="bodypartGeneric"
                key="bodypartGeneric"
                name="bodypartGeneric"
                width="100%"
                placeholder="Bodypart Generic"
                Value={order.bodypartGeneric}
                onChange={(event) =>
                  inputChangedHandler(event, "bodypartGeneric")
                }
                disabled={true}
              />
            </td>
          </tr>
          <tr>
            <td title={"Study Protocol generic"}>PT-G:</td>
            <td>
              <Input
                id="protocolGeneric"
                key="protocolGeneric"
                label="protocolGeneric"
                name="protocolGeneric"
                textTransform="capitalize"
                width="96%"
                placeholder="Protocol Generic"
                Value={order.protocolGeneric}
                onChange={(event) =>
                  inputChangedHandler(event, "protocolGeneric")
                }
                disabled={true}
              />
            </td>
            <td title={"Purpose of study generic"}>PP-G:</td>
            <td>
              {" "}
              <Input
                id="purposeOfStudyGeneric"
                key="purposeOfStudyGeneric"
                label="purposeOfStudyGeneric"
                name="purposeOfStudyGeneric"
                textTransform="capitalize"
                width="100%"
                placeholder="Purpose Of Study Generic"
                Value={order.purposeOfStudyGeneric}
                onChange={(event) =>
                  inputChangedHandler(event, "purposeOfStudyGeneric")
                }
                disabled={true}
              />
            </td>
          </tr>

          <tr>
            <td title={"Laterality generic"}>LT-G:</td>
            <td>
              <Input
                id="lateralityGeneric"
                key="lateralityGeneric"
                label="lateralityGeneric"
                name="lateralityGeneric"
                textTransform="capitalize"
                width="96%"
                placeholder="Laterality Generic"
                Value={order.lateralityGeneric}
                onChange={(event) =>
                  inputChangedHandler(event, "lateralityGeneric")
                }
                disabled={true}
              />
            </td>
            <td title={"Bodypart group generic"}>BG-G:</td>
            <td>
              <Input
                id="bodypartGroupGeneric"
                key="bodypartGroupGeneric"
                label="bodypartGroupGeneric"
                name="bodypartGroupGeneric"
                textTransform="capitalize"
                width="100%"
                placeholder="Bodypart Group Generic"
                Value={order.bodypartGroupGeneric}
                onChange={(event) =>
                  inputChangedHandler(event, "bodypartGroupGeneric")
                }
                disabled={true}
              />
            </td>
          </tr>
          <tr>
            <td
                title={"speciality"}
              >
                SPC:
              </td>
            <td>
            <Input
                id="speciality"
                key="speciality"
                label="speciality"
                name="speciality"
                textTransform="capitalize"
                width="96%"
                placeholder="speciality"
                Value={order.speciality}
                onChange={(event) =>
                  inputChangedHandler(event, "speciality")
                }
                disabled={true}
              />
              </td>
            </tr>
        </table>
        {order.is_pregnancy_flow && (
          <table style={{ width: "100%" }}>
            <tr>
              <td
                title={"Pregnancy Weeks"}
                style={{ width: "5%", fontSize: "14" }}
              >
                Wks:
              </td>
              <td>
                <Input
                  id="weeks_since_pregnant"
                  key="weeks_since_pregnant"
                  label="weeks_since_pregnant"
                  name="pregnancyweeks_since_pregnant_weeks"
                  // textTransform="capitalize"
                  // width="42%"
                  placeholder="Pregnancy weeks"
                  customStyle={{ width: "155px" }}
                  Value={order.weeks_since_pregnant}
                  onChange={(event) => {
                    inputChangedHandler(event, "weeks_since_pregnant");
                    operatorNotesFetchHandler(true);
                  }}
                />
              </td>
            </tr>
            
          </table>
        )}

        <table style={{ width: "100%" }}>
          <tr style={{ width: "100%" }}>
            <td style={{ width: "6.5%", fontSize: "14" }} title={"Room Name"}>
              RM:
            </td>
            <td
              style={{
                width: "25%",
                fontSize: "14",
                marginLeft: "10px",
                marginRight: "10px",
              }}
            >
              <Input
                id="roomName"
                key="roomName"
                label="roomName"
                name="roomName"
                // textTransform="capitalize"
                width="100%"
                placeholder="Room Name"
                // disabled={true}
                Value={order.roomName}
                onChange={(event) => inputChangedHandler(event, "roomName")}
                customStyle={{ textTransform: "uppercase", marginRight: "5px" }}
              />
            </td>
            <td
              style={{ width: "7%", fontSize: "16", paddingLeft: "5px" }}
              title={"Appointment date"}
            >
              A.D:
            </td>
            <td>
              <div>{dateTimePicker()}</div>
            </td>
          </tr>
        </table>
      </div>
    </div>
  );
};

export default AddmoreOrder;
